var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0C7.17762 0 0 7.17745 0 15.9999C0 24.8224 7.17762 32 15.9999 32C24.8222 32 31.9998 24.8224 31.9998 15.9999C31.9998 7.17745 24.8224 0 15.9999 0ZM25.1874 13.2974L15.1354 23.3493C14.708 23.7767 14.1399 24.012 13.5355 24.012C12.9311 24.012 12.3629 23.7767 11.9355 23.3493L6.81248 18.2263C6.38507 17.7989 6.14967 17.2307 6.14967 16.6263C6.14967 16.0218 6.38507 15.4536 6.81248 15.0262C7.23972 14.5988 7.80788 14.3634 8.41242 14.3634C9.01681 14.3634 9.58512 14.5988 10.0124 15.0264L13.5353 18.5492L21.9871 10.0973C22.4145 9.66994 22.9827 9.4347 23.5871 9.4347C24.1915 9.4347 24.7596 9.66994 25.187 10.0973C26.0695 10.9799 26.0695 12.4152 25.1874 13.2974Z",
    fill: "#11D500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.606bee6863306be4d13f8a2e35ea7637.svg";
export { ForwardRef as ReactComponent };